import { HttpCancelledError, HttpResponseError } from '@inertiajs/core';

export const isHttpCancelled = (error: unknown): boolean => error instanceof HttpCancelledError;

export const httpErrorStatus = (error: unknown): number | null => (
  error instanceof HttpResponseError ? error.response.status : null
);

export const isSessionExpired = (error: unknown): boolean => {
  const status = httpErrorStatus(error);

  return status === 401 || status === 419;
};

/** Thrown by `@/Composables/useHttp` when a request comes back 422. */
export class HttpValidationError extends Error {
  constructor(url: string) {
    super(`Request failed validation (${url})`);
    this.name = 'HttpValidationError';
  }
}
